/**
 * @generated SignedSource<<595b269ed4b84809887160e30bcda3aa>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JiraInstance_jiraInstances$data = {
  readonly jiraInstances: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly clientId: string | null | undefined;
        readonly defaultSpace: {
          readonly key: string;
          readonly name: string;
        } | null | undefined;
        readonly defaultWorkType: {
          readonly name: string;
        } | null | undefined;
        readonly id: string;
        readonly issueLimitHard: number;
        readonly issueLimitSoft: number;
        readonly name: string | null | undefined;
        readonly spaces: ReadonlyArray<{
          readonly key: string;
          readonly name: string;
          readonly workTypes: ReadonlyArray<{
            readonly iconUrl: string;
            readonly name: string;
          }>;
        }>;
        readonly url: string;
        readonly username: string | null | undefined;
        readonly uuid: any;
      };
    }> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "JiraInstance_jiraInstances";
};
export type JiraInstance_jiraInstances$key = {
  readonly " $data"?: JiraInstance_jiraInstances$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraInstance_jiraInstances">;
};

import JiraInstancePaginationQuery_graphql from './JiraInstancePaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jiraInstances"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 50,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [],
      "operation": JiraInstancePaginationQuery_graphql
    }
  },
  "name": "JiraInstance_jiraInstances",
  "selections": [
    {
      "alias": "jiraInstances",
      "args": null,
      "concreteType": "JiraInstanceConnection",
      "kind": "LinkedField",
      "name": "__JiraInstance__jiraInstances_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "JiraInstanceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "JiraInstance",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "uuid",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "url",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "username",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "clientId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "issueLimitSoft",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "issueLimitHard",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JiraSpace",
                  "kind": "LinkedField",
                  "name": "spaces",
                  "plural": true,
                  "selections": [
                    (v2/*:: as any*/),
                    (v1/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "JiraWorkType",
                      "kind": "LinkedField",
                      "name": "workTypes",
                      "plural": true,
                      "selections": [
                        (v1/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "iconUrl",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JiraSpace",
                  "kind": "LinkedField",
                  "name": "defaultSpace",
                  "plural": false,
                  "selections": [
                    (v2/*:: as any*/),
                    (v1/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "JiraWorkType",
                  "kind": "LinkedField",
                  "name": "defaultWorkType",
                  "plural": false,
                  "selections": [
                    (v1/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "45849db5b5e8498453a6b89f2cee8241";

export default node;
